class DripProductActions extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('click', async (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.hasAttribute('data-share') && navigator.share) {
        try { await navigator.share({ title: this.dataset.title, url: this.dataset.url }); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      if (button.matches('[data-share],[data-copy]')) {
        try {
          await navigator.clipboard.writeText(this.dataset.url);
          this.querySelector('[data-share-status]').textContent = this.dataset.copied;
          button.textContent = this.dataset.copied;
        } catch {
          this.querySelector('[data-share-fallback]').hidden = false;
          this.querySelector('input').select();
        }
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
class DripMoreProducts extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.page = 1; this.lastPage = Infinity; this.queue = []; this.busy = false;
    this.querySelector('[data-more]').addEventListener('click', () => this.more(), { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  async more() {
    if (this.busy) return;
    const button = this.querySelector('[data-more]');
    const status = this.querySelector('[data-more-status]');
    const grid = this.querySelector('[data-more-grid]');
    const label = button.textContent;
    const seen = new Set([this.dataset.productId, ...Array.from(this.closest('product-recommendations').querySelectorAll('product-card[data-product-id]'), e => e.dataset.productId)]);
    this.busy = true; button.disabled = true; button.textContent = this.dataset.loading;
    status.textContent = '';
    try {
      while (this.queue.length < 4 && this.page <= this.lastPage) {
        const url = new URL(this.dataset.collectionUrl, location.origin);
        url.searchParams.set('page', String(this.page));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('ul.product-grid');
        if (!source) throw new Error('Product grid unavailable');
        this.lastPage = Number(source.dataset.lastPage || 1);
        for (const item of source.children) {
          const card = item.querySelector('product-card[data-product-id]');
          if (!card || seen.has(card.dataset.productId) || card.dataset.productType !== this.dataset.productType) continue;
          seen.add(card.dataset.productId);
          // Remove collection-only reveal animation state and prevent duplicate DOM IDs.
          item.removeAttribute('style'); item.classList.remove('scroll-trigger', 'animate--slide-in');
          for (const element of item.querySelectorAll('[id]')) element.id = 'more-' + this.dataset.productId + '-' + element.id;
          item.querySelectorAll('script').forEach(e => e.remove());
          this.queue.push(item);
        }
        this.page++;
      }
      const added = this.queue.splice(0, 4);
      grid.append(...added);
      if (!this.queue.length && this.page > this.lastPage) {
        button.hidden = true;
        status.textContent = this.dataset.complete;
      } else status.textContent = this.dataset.loaded;
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = this.dataset.error;
    } finally {
      this.busy = false; button.disabled = false; button.textContent = label;
    }
  }
}
if (!customElements.get('drip-product-actions')) customElements.define('drip-product-actions', DripProductActions);
if (!customElements.get('drip-more-products')) customElements.define('drip-more-products', DripMoreProducts);

